import React from "react";
import { Spin } from "antd";
import "./styles.scss";

interface ILoading {
  children?: React.ReactNode;
}

export const Loading = ({ children }: ILoading) => {
  return <div>{children || <Spin />}</div>;
};
